'use strict'
import { request } from '../../plugins/http'

export default async (data) =>{
    return await request.get('/responsavelNovoPedido', {params : {email : data}})
}